import { Contract } from "~/model/Contract"
import { ApprovalMode } from "~/model/ApprovalFlow"
import { Company } from "./Company"
import { User } from "./User"
import { DocWorkflowNos } from "~/model/ContractDocument"

export enum DocumentType {
  IMPORTANT = "IMPORTANT",
  CONTRACT = "CONTRACT",
  OTHER = "OTHER",
  INVOICE = "INVOICE",
  INSURANCE = "INSURANCE",
  OFFLINE = "OFFLINE",
  SHARE = "SHARE",
  OFFLINE_IMPORTANT = "OFFLINE_IMPORTANT",
  MULTI_UPLOAD = "MULTI_UPLOAD",
  MANAGEMENT_UPLOAD = "MANAGEMENT_UPLOAD",
  MANAGEMENT_UPLOAD_CHECKLIST = "MANAGEMENT_UPLOAD_CHECKLIST",
  REQUIREMENT = "REQUIREMENT",
}

export enum BizWorkflowValue {
  BIZ_1 = "BIZ_1",
  BIZ_2 = "BIZ_2",
  BIZ_3 = "BIZ_3",
  BIZ_4 = "BIZ_4",
  BIZ_5 = "BIZ_5",
  BIZ_6 = "BIZ_6",
  BIZ_7 = "BIZ_7",
  BIZ_8 = "BIZ_8",
  BIZ_9 = "BIZ_9",
  BIZ_10 = "BIZ_10",
  BIZ_11 = "BIZ_11",
  BIZ_12 = "BIZ_12",
}

export enum WorkflowAction {
  UPLOAD = "UPLOAD",
  SEND = "SEND",
  RECV = "RECV",
  SIGN = "SIGN",
}

export enum WorkflowActionId {
  UPLOAD = 1,
  SEND = 2,
  RECV = 3,
  SIGN = 4,
}

export enum WorkflowActor {
  CONTRACTOR = 1,
  AGENT = 2,
  MANAGEMENT = 3,
  RESIDENT = 4,
  GUARANTEE_01 = 5,
  GUARANTEE_02 = 6,
  OWNER_AGENCY = 7,
  COLLECTION_AGENCY = 7, // COLLECTION AGENCY ~ ONWER AGENCY
  OWNER = 8,
}

export enum GUEST_TYPE {
  CONTRACTOR = "CONTRACTOR",
  GUARANTEE_01 = "GUARANTEE_01",
  GUARANTEE_02 = "GUARANTEE_02",
  RESIDENT = "RESIDENT",
  OWNER_AGENCY = "OWNER_AGENCY",
  OWNER = "OWNER",
}

/**
 * ワークフローデータ
 */
export type WorkflowData = {
  actor: WorkflowActor
  type: WorkflowActionId
  target?: WorkflowActor
  approvals?: {
    contractDocumentId: number
    createdAt: Date
    data: {
      hash: string
      signedPdfId: string
      result: { [KEY in string]: string }
      forms?: ApprDataConfirm
    }
    id: number
    isRequest: boolean
    result: number
    userId: number
    workflowNo: number
  }[]
  columns: number[]
}
/**
 * ワークフロー
 */

export type ApprDataConfirm = {
  id: number
  name: string
  data: { title: string; value: string }[]
  cellData?: {
    title: string
    contents: {
      objectId: string
      element: string
    }[]
  }[][]
}[]

export type WorkflowDataDisplay = {
  type: number
  actor: number
  target: number
  columns: string[]
  result?: ContractWorkflow
  pdfId: string
  isSkip: boolean
  isApproval: boolean
  isSelfStep: boolean
  actorName: string
}

export type Workflow = {
  id: number
  type: string
  userId: number
  companyId: number
  name: string
  data: WorkflowData[]
  viewType: number
  lastEditUserId: number
  templateId?: number
  docWorkflowNo: DocWorkflowNos
}

export type BizWorkflow = {
  id: number
  type: DocumentType
  userId: number
  companyId: number
  name: string
  viewType: number
  lastEditUserId: number
  docWorkflowNo: DocWorkflowNos
  ledgerFlg: number
  paperDocFlg: boolean
  bizWorkflowList: {
    data: WorkflowData[]
    templateId?: number
    isConfirm?: boolean
    bizWorkflowValue?: string
    docWorkflowNo?: string
  }[]
}

/**
 * 契約ドキュメント
 */
export type Document = {
  id?: number
  workflowId: number
  workflowName: string
  workflowType: DocumentType
  workflowData: WorkflowResultData[]
  approvalFlowBlcId?: string

  workflow?: Workflow
  // workflows: ContractWorkflow[]
  contractId: number
  userId?: number
  // status?: number
  approvalUsers?: { id: number; email: string; company: Company }[]
  approvalMode?: ApprovalMode
  workflowPosition?: number
  createdAt?: Date
  updatedAt?: Date
  deletedAt?: Date | null
  isRequireUpload?: 0 | 1
  documentFiles?: MultiUpload[]
  docWorkflowNo?: DocWorkflowNos
}

/**
 * ファイルオブジェクト
 */
export type FileObject = {
  id: string
  mimetype: string
  name: string
  size: number
  fileId?: string
}

export type UploadDocument = {
  id?: number
  contractId: number
  workflowId: number
  workflowName?: string
  workflowType?: DocumentType
  workflowData?: WorkflowResultData[]
  file: FileObject
  fileBlob?: any
  notRequireUpload: boolean
  documentFiles?: (MultiUpload & File)[]
  version?: number
  docWorkflowNo?: DocWorkflowNos
}

export type UploadedBucketFile = {
  hashFileName: string
  fileName: string
}

/**
 * 契約ワークフローデータ
 */

export type WorkflowResultData = WorkflowData & {
  result?: ContractWorkflow
}
export type ContractWorkflow = {
  id: number
  contractDocumentId: number
  contractDocument?: Document
  workflowNo: number
  userId: number
  data: FileObject | { hash: string } | SignData
  hash: string
  type: WorkflowAction
  createdAt: Date
  deletedAt: Date | null
  user: User
  isSkip: boolean
}

export type SignData = {
  result: { [KEY in string]: any }
  signedPdfId: string
}

export type DownloadData = {
  workflowName: string
  date: Date
  isComplete: boolean
  pdfId: string
  receiver?: WorkflowActor
  isDownload?: boolean
  fullName?: string
  companyName?: string
  isSign?: boolean
}

export type DocumentSendConfirm = {
  contract: Contract
  sendData: {
    [ACTOR in string]: {
      id: number
      workflowId: number
      workflowName: string
      workflowType: DocumentType
      file: FileObject
      mailType: string
      files: MultiUpload[]
    }[]
  }
  targets: {
    [ACTOR in string]: {
      email: string
      name: string
      company?: string
    }
  }
}

export interface MultiUpload {
  id: number
  uploadBy: number
  docId: number
  hashFileName: string
  fileName: string
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  name: string
}
